import React, { useState } from 'react';
import ImageLoader from 'components/image-loader';
import { ProvinceOrStateCode, countryCodeFromProvinceOrState } from 'utils/province_or_state';
import { CountryCodeList } from 'types/countries';
import styles from './style.module.scss';

import type Listing from 'data/listing';
import { mlsProviderIds } from 'constants/mlsProviderIds';

type BrokerageLogoListingData = Pick<Listing, 'province' | 'isCrea' | 'url'>;

type BrokerageLogosProps = {
  providerId: Listing['providerId'];
  listing?: BrokerageLogoListingData;
};

function ProviderLogo({ providerId, className }: { providerId: number; className?: string }) {
  const [hasError, setHasError] = useState(false);

  if (hasError) return null;

  // eslint-disable-next-line @next/next/no-img-element
  return <img className={className} src={`https://zoocasa.s3.amazonaws.com/provider-logos/PROV_LOGO_${providerId}.png`} alt="MLS logo" onError={() => setHasError(true)} />;
}

export default function BrokerageLogos({ providerId, listing }: BrokerageLogosProps) {
  const isListing = !!listing;
  const countryCode = countryCodeFromProvinceOrState(listing?.province?.toLowerCase() as ProvinceOrStateCode);
  const isAmericanListing = !isListing || countryCode == CountryCodeList.UNITED_STATES;
  const isCanadianListing = isListing && countryCode == CountryCodeList.CANADA;
  const canadaMlsSource = '/assets/images/listing-page/logo-mls.svg';

  const realtorLogo = () => {
    if (isAmericanListing
      || providerId === mlsProviderIds.nsaor
      || providerId === mlsProviderIds.centris
      || providerId === mlsProviderIds.cnnalar
      || providerId === mlsProviderIds.cnnalar_v) {
      return <ProviderLogo providerId={providerId} className={styles['provider-logo']} />;
    } else if (listing.isCrea) {
      const url = listing.url ? listing.url.startsWith('https://') ? listing.url : `https://${listing.url}` : 'https://www.realtor.ca/en';
      return (
        <a href={url} target="_blank" rel="noreferrer" className={styles['crea-logo']}>
          <ImageLoader src="/next/assets/images/powered_by_realtor.svg" alt="Powered by: REALTOR.ca" width="3.6em" height="3.6em" />
        </a>
      );
    } else {
      return <ImageLoader src="/assets/images/listing-page/logo-realtor.svg" alt="Realtor logo" className={styles['realtor-logo']} />;
    }
  };

  return (
    <div className={styles.component}>
      {realtorLogo()}
      {isCanadianListing && <ImageLoader src={canadaMlsSource} alt="MLS logo" width="3.6em" height="25px" className={styles['mls-logo']}/>}
    </div>
  );
}
